import {http} from '@/helpers/http-helper';

export const getAttachmentPreview = (attachmentId) => {
    return new Promise((resolve, reject) => {
        const url = 'attachments/' + attachmentId + '/preview';
        http.get(url, null, 'blob')
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const createOtherAttachment = (attachment, attachmentDescription) => {
    return new Promise((resolve, reject) => {
        const url = '/other-attachments';

        let formData = new FormData();
        formData.append('attachment', attachment);
        formData.append('description', attachmentDescription);

        http.post(url, formData)
            .then((response) => {
                if (response.status === 201) {
                    resolve(response.data);
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export const deleteOtherAttachment = (attachmentId) => {
    return new Promise((resolve, reject) => {
        const url = `/other-attachments/${attachmentId}`;

        http.delete(url)
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    resolve();
                } else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};